// Localizacao pt-BR para o material-table (v1.x).
// Cobre as chaves usadas na nossa base; quem precisar de algo nao listado adiciona aqui.
export const materialTableLocalizationPtBR = {
  body: {
    emptyDataSourceMessage: 'Nenhum registro para exibir.',
    addTooltip: 'Adicionar',
    deleteTooltip: 'Remover',
    editTooltip: 'Editar',
    filterRow: { filterTooltip: 'Filtrar' },
    editRow: {
      deleteText: 'Confirma remoção deste registro?',
      cancelTooltip: 'Cancelar',
      saveTooltip: 'Salvar',
    },
  },
  grouping: {
    placeholder: 'Arraste cabeçalhos para agrupar',
    groupedBy: 'Agrupado por:',
  },
  header: {
    actions: 'Ações',
  },
  pagination: {
    labelDisplayedRows: '{from}-{to} de {count}',
    labelRowsSelect: 'linhas',
    labelRowsPerPage: 'Linhas por página:',
    firstAriaLabel: 'Primeira página',
    firstTooltip: 'Primeira página',
    previousAriaLabel: 'Página anterior',
    previousTooltip: 'Página anterior',
    nextAriaLabel: 'Próxima página',
    nextTooltip: 'Próxima página',
    lastAriaLabel: 'Última página',
    lastTooltip: 'Última página',
  },
  toolbar: {
    addRemoveColumns: 'Adicionar/remover colunas',
    nRowsSelected: '{0} linha(s) selecionada(s)',
    showColumnsTitle: 'Mostrar colunas',
    showColumnsAriaLabel: 'Mostrar colunas',
    exportTitle: 'Exportar',
    exportAriaLabel: 'Exportar',
    exportName: 'Exportar como CSV',
    searchTooltip: 'Pesquisar',
    searchPlaceholder: 'Pesquisar',
    searchAriaLabel: 'Pesquisar',
    clearSearchAriaLabel: 'Limpar pesquisa',
  },
};

export default materialTableLocalizationPtBR;
